import React, { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';

const RevisionModal34 = () => {
  const {
    showRevisionModal,
    setShowRevisionModal,
    revisionProject,
    revisionData,
    setRevisionData,  // ADD THIS LINE - it was missing
    setProjects,
    setShowRevisionPaymentModal,
    setRevisionProject,  // ADD THIS LINE - might be needed
    showNotification,
    typeNames,
    documentTypes
  } = useAppContext();

  const [feedback, setFeedback] = useState(revisionData?.feedback || '');

  if (!showRevisionModal || !revisionProject || !revisionData) return null;

  // Only handle Stage 3 & 4 projects
  if (revisionProject?.stage < 3) return null;

  const isAdditionalRevision = revisionData.isAdditional;
  const revisionFee = revisionData.fee || 0;

  const handleSubmitRevision = async () => {
    if (!feedback.trim()) {
      showNotification("Feedback Required", "Please provide feedback for the revision", "warning");
      return;
    }

    if (isAdditionalRevision) {
      // For additional revisions, show payment modal
      setRevisionData({
        ...revisionData,
        feedback: feedback
      });
      setShowRevisionModal(false);
      setShowRevisionPaymentModal(true);
    } else {
      // For included revisions, process immediately
      try {
        const updatedProject = {
          ...revisionProject,
          status: `revision-${revisionData.revisionNumber}-requested`,
          documentRevisionTracking: {
            ...revisionProject.documentRevisionTracking,
            [revisionData.documentType]: {
              ...revisionProject.documentRevisionTracking[revisionData.documentType],
              revisionsUsed: revisionData.revisionNumber
            }
          },
          communications: [
            ...(revisionProject.communications || []),
            {
              type: "client",
              sender: revisionProject.client,
              message: `Revision ${revisionData.revisionNumber} requested for ${revisionData.documentTypeLabel}: ${feedback}`,
              timestamp: new Date().toISOString().slice(0, 16).replace('T', ' ')
            },
            {
              type: "architect",
              sender: "planAIdesign",
              message: `Revision ${revisionData.revisionNumber} request received for ${revisionData.documentTypeLabel}. We'll begin work on your revisions and have them ready within 3-5 business days.`,
              timestamp: new Date(Date.now() + 1000).toISOString().slice(0, 16).replace('T', ' ')
            }
          ]
        };

        // Save to Firebase
        await setDoc(doc(db, 'projects', revisionProject.id), updatedProject);

        // Update local state
        setProjects(prev => prev.map(p => 
          p.id === revisionProject.id ? updatedProject : p
        ));

        showNotification("Revision Requested", `Revision ${revisionData.revisionNumber} for ${revisionData.documentTypeLabel} has been submitted`, "success");
        setShowRevisionModal(false);
      } catch (error) {
        console.error('Error submitting revision:', error);
        showNotification("Error", "Failed to submit revision request", "error");
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-xl max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold">
            Request Revision {revisionData.revisionNumber}
          </h3>
          <button 
            onClick={() => setShowRevisionModal(false)} 
            className="text-2xl text-slate-400 hover:text-slate-600"
          >✕</button>
        </div>

        <div className="mb-6">
          <div className="bg-blue-50 p-4 rounded-lg mb-4">
            <h4 className="font-semibold text-lg mb-2">{revisionProject.name}</h4>
            <p className="text-sm text-gray-600">
              {typeNames[revisionProject.type]} | Stage {revisionProject.stage}
            </p>
            <div className="mt-3 pt-3 border-t border-blue-200">
              <p className="text-sm">
                <strong>Document Type:</strong> {revisionData.documentTypeLabel}
              </p>
              <p className="text-sm">
                <strong>Revision Number:</strong> {revisionData.revisionNumber}
              </p>
              <p className="text-sm">
                <strong>Revisions Used:</strong> {
                  revisionProject.documentRevisionTracking?.[revisionData.documentType]?.revisionsUsed || 0
                }/{
                  revisionProject.documentRevisionTracking?.[revisionData.documentType]?.maxIncluded || 1
                } included
              </p>
              {isAdditionalRevision && (
                <p className="text-sm text-orange-600 font-semibold mt-2">
                  Additional Revision Fee: ${revisionFee}
                </p>
              )}
            </div>
          </div>

          <div>
            <label className="block font-semibold mb-2">Revision Feedback *</label>
            <textarea
              rows={6}
              placeholder="Please describe the changes you'd like to the documentation..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
            />
          </div>

          {isAdditionalRevision && (
            <div className="mt-4 bg-orange-50 p-3 rounded-lg">
              <p className="text-sm text-orange-800">
                <strong>⚠️ Additional Revision:</strong> This revision exceeds your included revisions for {revisionData.documentTypeLabel}. 
                A fee of ${revisionFee} will be required before work can begin.
              </p>
            </div>
          )}
        </div>

        <div className="flex gap-4">
          <button 
            onClick={() => setShowRevisionModal(false)}
            className="flex-1 bg-gray-500 text-white py-3 rounded-lg font-semibold hover:bg-gray-600"
          >
            Cancel
          </button>
          <button 
            onClick={handleSubmitRevision}
            className="flex-1 bg-orange-600 text-white py-3 rounded-lg font-semibold hover:bg-orange-700"
          >
            {isAdditionalRevision ? `Continue to Payment ($${revisionFee})` : 'Submit Revision Request'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevisionModal34;